import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var newRelicCall = function newRelicCall(_ref) {
  var msg = _ref.msg,
      level = _ref.level,
      customFilter = _ref.customFilter;

  if (process.client && window && window.newrelic) {
    var newRelicMessage = msg;

    if ((typeof message === "undefined" ? "undefined" : _typeof(message)) === 'object') {
      newRelicMessage = JSON.stringify(msg);
    }

    window.newrelic.noticeError(newRelicMessage, _objectSpread({
      'mdm-errors': 'mdm-errors',
      'log-level': level || 'error',
      'mdm-console': level || 'error'
    }, customFilter && {
      'custom-filter': customFilter
    }));
  }
};
export var transformArgumentsToString = function transformArgumentsToString(args) {
  return Object.values(args).map(function (arg) {
    return _typeof(arg) === 'object' ? JSON.stringify(arg) : arg;
  }).join(' ');
};
export var logError = function logError(_ref2) {
  var msg = _ref2.msg;
  newRelicCall({
    msg: msg
  });
  console.error(msg);
};